import { gql } from '@apollo/client';

/**
 * The count on the sidebar's Follow-ups entry: open follow-ups dated before now,
 * every admin's. `take: 1` is the API's minimum; only `total` is used.
 *
 * Mutations that close or set a follow-up (crmLogCall, crmCompleteFollowUp) evict
 * `crmCalls` (forgetCallData in calls/LogCallForm.tsx), so the count, when shown,
 * asks again and moves with them: nothing re-reads it on a timer. Card 21 chose
 * that over `refetchQueries: ['CrmFollowUpsDue']`, which warns where the count is
 * not mounted.
 */
export const CRM_FOLLOW_UPS_DUE = gql`
  query CrmFollowUpsDue($due: DateTime!) {
    crmCalls(filter: { followUp: OPEN, followUpAt: { to: $due } }, order: FOLLOW_UP, take: 1) {
      total
    }
  }
`;
